export default __webpack_public_path__ + "static/media/client1.e1ba4344.png";